import styles from "./index.module.less";
import { ButtonField } from "@wk/components-react16";
import { useNavigate } from "react-router-dom";

const Question = () => {
  const navigate = useNavigate();

  const faqData = [
    {
      title: "赛程赛制",
      list: [
        {
          question: "是否对参赛者的专业、学历、医院等级等有要求？",
          answer:
            "无要求，面向全国各级医疗机构的临床医生、医学生及相关医疗从业人员。",
        },
        {
          question: "是否允许团队参赛？团队成员人数和构成是否有规定？",
          answer:
            "允许团队参赛，团队成员人数不做限制。但奖励机制按照参赛作品数量对应，不对应人数。",
        },
        {
          question: "往届获奖者是否可以再次参赛？",
          answer:
            "允许往届获奖者参赛，但需提交新的案例，不能重复使用已获奖案例。",
        },
        {
          question:
            "案例类型是否有明确限制？例如，是否必须是疑难病例、罕见病例或具有教学意义的病例？",
          answer:
            "案例类型分为：临床、住培、教学、科研、管理。但疑难病例、罕见病例等具有创新性的病例更具有竞争优势。",
        },
        {
          question: "案例时间范围是否有要求？例如，是否必须是近期发生的病例？",
          answer:
            "要求案例为近1-2年内发生的病例，以确保案例的时效性和参考价值。",
        },
        {
          question: "是否可以使用已发表或已参加其他比赛的案例？",
          answer: "可以。",
        },
        {
          question: "案例中涉及的患者隐私信息如何处理？",
          answer: "案例必须隐去患者隐私信息（如姓名、身份证号等）。",
        },
        {
          question: "比赛分为几个阶段？每个阶段的具体时间和安排是怎样的？",
          answer:
            "比赛分为初赛和决赛。进入决赛后，主办方通过邮件或短信通知选手，并邀请参加决赛赛前训练营。具体时间参考官网中赛程安排。",
        },
        {
          question: "是否需要现场演讲？",
          answer:
            "不设置现场演讲。但获奖后，主办方将邀请获奖选手线上录制课程分享。",
        },
        {
          question: "比赛设有哪些奖项？每个奖项的获奖人数和奖励是什么？",
          answer:
            "比赛设置“优秀机构组织奖”、“卓越案例奖”、“优秀案例奖”，获奖总人数在30左右。奖励包含奖品、UpToDate使用权限。",
          table: {
            headList: ["奖项", "奖品"],
            tableList: [
              {
                first: "优秀机构组织奖",
                list: ["机构奖杯", "获奖证书"],
              },
              {
                first: "卓越案例奖",
                list: [
                  "UpToDate临床顾问全平台账号1年使用权",
                  "奖品（价值1000元）",
                  "获奖证书",
                ],
              },
              {
                first: "优秀案例奖",
                list: [
                  "UpToDate临床顾问移动端账号1年使用权",
                  "奖品（价值800元）",
                  "获奖证书",
                ],
              },
            ],
          },
        },
        {
          question: "问：获奖后UpToDate 账号使用权限如何分配？",
          answer: "每部获奖作品将获赠一个 UpToDate 账号，默认授予决赛时登记的作者。若团队获奖，经登记的第一作者同意，可转让给该作品登记的其他作者，但转让后不可变更且不可转予未参与案例创作的外部人员。",
        },
      ],
    },
    {
      title: "投稿",
      list: [
        {
          question: "投稿是通过官方网站、邮箱还是其他平台？",
          answer: "目前仅支持官方网站投稿。",
        },
        {
          question: "投稿时需要提交哪些材料？例如，案例报告、PPT、视频等？",
          answer:
            "初赛投稿作品可接受PPT或PDF文件。如进入决赛，临床/住培案例需要按照中国临床案例成果数据库标准改写为完整的案例报告，采用Word或PDF文件投稿。",
        },
        {
          question: "投稿材料的格式和大小是否有要求？",
          answer: "PPT大小不超过100M。",
        },
        {
          question: "案例报告是否有固定模板？字数要求是多少？",
          answer: "案例无固定模板，不做字数要求",
        },
        {
          question:
            "案例报告需要包含哪些内容？例如，病史、检查、诊断、治疗、随访等？",
          answer:
            "病史、检查、诊断、治疗、随访及UpToDate的应用。详见评分标准。",
        },
        {
          question: "如何平衡案例报告的完整性和简洁性？",
          answer: "两者均占分值。详见评分标准。",
        },
        {
          question: "投稿后是否可以修改或撤回？",
          answer: "投稿后，选手本人无法修改或撤回。",
        },
        {
          question: "如何查询投稿状态和评审结果？",
          answer: "关注赛事官网及UpToDate公众号。",
        },
        {
          question: "比赛组委会的联系方式是什么？",
          answer: "health@wolterskluwer.cn",
        },
      ],
    },
    {
      title: "中国临床案例成果数据库收录相关问题",
      list: [
        {
          question: "何种案例能够被中国临床案例成果数据库收纳？",
          answer:
            "获得“卓越案例奖”的临床及住培案例将被中国临床案例成果数据库直接收录。",
        },
        {
          question: "如果投稿至中国临床案例成果数据库，是否允许多位作者？",
          answer: "投稿案例允许多个作者，但第一作者和通信作者均只能有一位。",
        },
        {
          question:
            "如果未能获得“卓越案例奖”，我是否依然可以尝试投稿中国临床案例成果数据库？",
          answer: "可以，请您按照中国临床案例成果数据库要求自行投稿。",
        },
      ],
    },
  ];

  return (
    <div className={styles["question-box"]}>
      <div className="title">常见问题</div>
      <div className="content">
        {faqData.map((item, index) => {
          return (
            <div className="faq-item" key={index}>
              <div className="faq-title">{item.title}:</div>
              {item.list.map((item, index) => {
                return (
                  <div className="faq-list" key={index}>
                    <div className="faq-question">
                      {index + 1}. {item.question}
                    </div>
                    <div className="faq-answer">{item.answer}</div>
                    {item["table"] && (
                      <div className="faq-table">
                        <table>
                          <thead>
                            <tr>
                              {item["table"].headList.map(
                                (headItem, headIndex) => {
                                  return (
                                    <th
                                      width={headIndex === 0 ? "20%" : "80%"}
                                      key={headIndex}
                                      style={{
                                        textAlign: "left",
                                      }}
                                      nowrap="nowrap"
                                    >
                                      {headItem}
                                    </th>
                                  );
                                }
                              )}
                            </tr>
                          </thead>

                          <tbody>
                            {item["table"].tableList.map(
                              (contentItem, contentIndex) => {
                                return (
                                  <tr key={contentIndex}>
                                    <td className="weight-cell" nowrap="nowrap">
                                      {contentItem.first}
                                    </td>

                                    <td>
                                      <ul>
                                        {contentItem.list.map(
                                          (content, contentIndex) => {
                                            return (
                                              <li key={contentIndex}>
                                                {content}
                                              </li>
                                            );
                                          }
                                        )}
                                      </ul>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>

      <div className="footer">
        <ButtonField mode={"ghost"}>
          <button
            type="button"
            onClick={() => {
              navigate(-1);
            }}
          >
            返回
          </button>
        </ButtonField>
      </div>
    </div>
  );
};
export default Question;
